import { Component, OnInit, Input, Output } from '@angular/core';
import { JurPerson } from '../../@core/data/jur-person';
import { Base64} from 'js-base64';
import { RestService } from '../../@core/utils/rest.service';
import { bank } from '../../@core/data/bank';

@Component({
  selector: 'ngx-reestr',
  templateUrl: './reestr.component.html',
  styleUrls: ['./reestr.component.scss']
})

export class ReestrComponent implements OnInit {
  public jurPerson:JurPerson;
  public banks: bank[];
  numberPayment:string;
  iik:string='';
 

  settings = {
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      number: {
        title: '№, п/п'
      },
      ID: {
        title: 'ИИН'
      },
      username: {
        title: 'ФИО'
      },
      date: {
        title: 'Дата рождения'
      },
      period: {
        title: 'Период платежа'
      },
      sum: {
        title: 'Сумма'
      }
    }
  };
    constructor(public rest:RestService) { }
   formPayment(){


  }
  paymentClick(){
    sessionStorage.setItem('NUMBER',this.numberPayment);
  
  }
  ngOnInit() {

    try
    {
      let base64 = sessionStorage.getItem("jurPerson").toString();
      let jsonString = Base64.decode(base64); 
      this.jurPerson =  <JurPerson>JSON.parse(jsonString);//TypedJSON.parse(jsonString, JurPerson);

      let bankJson = "";
      this.rest.getBanksList().subscribe((data: string) => {
        this.banks = <bank[]>JSON.parse(JSON.stringify(data));
      });
      let s:string = "";
    }
    catch(e)
    {
      console.error(e.message);
    }
    
  }
  

}
